import { RxJsonSchema, toTypedRxJsonSchema, ExtractDocumentTypeFromTypedRxJsonSchema } from 'rxdb';

export const F_JOURNAUX_SCHEMA_LITERAL = {
    title: 'Schéma Journaux',
    description: 'Décrit les Journaux',
    version: 0,
    keyCompression: false,
    primaryKey: { key : 'CBMARQ_PK', fields : ['CBMARQ'], separator : '' },
    type: 'object',
    properties: {
        CBMARQ_PK: { type: 'string', maxLength : 10 },
        CBMARQ: { type: 'number' },
        JO_TYPE: { type: 'number' },
        JO_NUM: { type: 'string' },
        JO_INTITULE: { type: ['string', 'null'] }
    },
    required: [ 'JO_NUM' ]  
} as const;

const schemaTyped = toTypedRxJsonSchema(F_JOURNAUX_SCHEMA_LITERAL);
export type RxFJournauxDocumentType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const F_JOURNAUX_SCHEMA: RxJsonSchema<RxFJournauxDocumentType> = F_JOURNAUX_SCHEMA_LITERAL;
